(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ActivityFleetController', ActivityFleetController);
    

    ActivityFleetController.$inject = [
        '$templateCache',
        '$rootScope'
    ];

    function ActivityFleetController($templateCache, $rootScope){
        // jshint maxstatements:false

        var icons = {
                     0:  'content/img/aseguradoras/asitur/asitur-imagotipo.png',
                     1:  'content/img/aseguradoras/racc/racc-imagotipo.png',
                     2:  'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
                     3:  'content/img/aseguradoras/europ/europ-imagotipo.png',
                     4:  'content/img/aseguradoras/mm/mm-imagotipo.png',
                     5:  'content/img/aseguradoras/race/race-imagotipo.png',
                     6:  'content/img/aseguradoras/allianz/allianz-imagotipo.png',
                     7:  'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
                     8:  'content/img/aseguradoras/ld/ld-imagotipo.png',
                 };


        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
             columnDefs: [
                {
//OJO!!! Hay que cambiar los logos de las empresas aseguradoras por el tipo de vehiculo. (taxi, grua, bus etc...)
                    field: 'type', 
                    displayName: 'Tipo',
                    cellTemplate: $templateCache.get('app/views/orders/common_templates/clienteCellTemplate.html'),
                    width: 45,
                    resizable: true
                },
                {
                    name: 'id',
                    displayName: 'Id.',
                    minWidth: 60,
                    maxWidth: 75,
                    resizable: true


                },
                {

                    field: 'enrollment',
                    displayName: 'Matrícula',
                    minWidth: 75,
                    maxWidth: 90,
                    resizable: true

                },
                {
                    field: 'description',
                    displayName: 'Descripción',
                    resizable: true

                },
                {
                    field: 'brand',
                    displayName: 'Marca',
                    minWidth: 100,
                    maxWidth: 120,
                    resizable: true

                },
                {
                    field: 'model',
                    displayName: 'Modelo', 
                    minWidth: 100,
                    maxWidth: 120,
                    resizable: true

                 },
                 {
                    field: 'version',
                    displayName: 'Versión',
                    minWidth: 100,
                    maxWidth: 120,
                    resizable: true

                 },
                 {
                    field: 'group',
                    displayName: 'Grupo',
                    minWidth: 100,
                    maxWidth: 120,
                    resizable: true

                 },
                 {
                    field: 'modify',
                    displayName: 'Acciones',
                    minWidth: 100,
                    maxWidth: 120,
                    resizable: true

                 }
             ],
             data: vm.gridData,
        };

        vm.getBrandLogo = getBrandLogo;
        vm.goToOrdenNueva = goToOrdenNueva;

        (function () {
            loadData();
        })();

        function loadData(){
            for(var i = 0; i < 20; i++){
                var icon = i % Object.keys(icons).length;
                var row = { 'insuranceCompanyCode' : icon, 
                    'id': '001', 'enrollment' : 'B-1234-LL', 
                    'description' : 'Lorem ipsum dolor sit amet consecteur adipiscing elit', 
                    'brand': 'BMWDD', 
                    'model' : '330', 
                    'version' : '1234567890', 
                    'group' : 'PLATAFORMAS', 
                    'modify' : 'editar | eliminar'
                };
                vm.gridData.push(row);
            }
        }
        
        function getBrandLogo(icon) {
            return icons[icon] || 'undefined';
        }
        
        function goToOrdenNueva() {
            $rootScope.tabManager.goToOrdenes(null);
        }        
    }

})();